import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/styles';
import { useMediaQuery } from '@material-ui/core';
import { Sidebar, Topbar, Footer } from './components';
import { useLogOut } from 'hooks';

const useStyles = makeStyles(theme => ({
   root: {
      paddingTop: 56,
      height: '100%',
      [theme.breakpoints.up('sm')]: {
         paddingTop: 64
      }
   },
   shiftContent: {
      paddingLeft: 240
   },
   content: {
      height: '100%'
   }
}));

const Main = props => {
   const { children } = props;

   const logOut = useLogOut();

   const classes = useStyles();
   const theme = useTheme();
   const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
      defaultMatches: true
   });

   const [openSidebar, setOpenSidebar] = useState(false);

   const handleSidebarOpen = () => {
      setOpenSidebar(true);
   };

   const handleSidebarClose = () => {
      setOpenSidebar(false);
   };

   const shouldOpenSidebar = isDesktop ? true : openSidebar;

   return (
      <div
         className={clsx({
            [classes.root]: true,
            [classes.shiftContent]: isDesktop
         })}
      >
         <Topbar onSidebarOpen={handleSidebarOpen} onLogOutClick={logOut} />
         <Sidebar
            onClose={handleSidebarClose}
            open={shouldOpenSidebar}
            variant={isDesktop ? 'persistent' : 'temporary'}
         />
         <main className={classes.content}>
            {children}
            <Footer empresa="Data Service" website="https://www.dscont.pe/" />
         </main>
      </div>
   );
};

Main.propTypes = {
   children: PropTypes.node
};

export default Main;
